import React from 'react';
import {CommonShow} from '../Common';
import {getShowFields} from './Common';

export const MaterialSubFamilyShow = props => (
  <CommonShow
    {...{
      ...props,
      fields: getShowFields(),
    }}
  />
);
